import { createFilterSelectList } from '@adv-frontend/filters';
import { VAT_ITEMS } from '#shared/lib/constants';
import { VAT_FILTER_ID, VAT_FILTER_TITLE } from '../../constants';

export const createVatFilter = () =>
    createFilterSelectList<string, string>({
        id: VAT_FILTER_ID,
        title: VAT_FILTER_TITLE,
        items: VAT_ITEMS,
    });
